var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"container-payments row"},[_c('b-col',{attrs:{"lg":"6"}},[_c('profile-payment-wallet')],1),_c('b-col',{staticClass:"mt-3 mt-md-0",attrs:{"lg":"6"}},[_c('profile-payment-cards')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }